import { Poster } from "PosterEditor/poster/Poster";
import styles from "./PosterStage.module.css";
import { useEditorUI } from "PosterEditor/use-editor-ui";
import { EditorContextType } from "PosterEditor/PosterEditor";

interface PosterStageProps {
  onShowContextualEditor: (show: boolean) => void;
  contextType?: EditorContextType;
}

export const PosterStage = (props: PosterStageProps) => {
  return (
    <div className={styles.mapContainer}>
      <div className={styles.mapAndLeftControlsContainer}>
        {props.contextType !== "rendering" && <ZoomControl />}
        <Poster
          onShowContextualEditor={props.onShowContextualEditor}
          contextType={props.contextType}
        />
      </div>
    </div>
  );
};

interface ZoomControlProps {}

const ZoomControl = (props: ZoomControlProps) => {
  const { zoomMapIn, zoomMapOut } = useEditorUI();
  return (
    <div className={styles.zoomControlContainer}>
      <button className={styles.zoomButton} onClick={() => zoomMapIn()}>
        +
      </button>
      <button className={styles.zoomButton} onClick={() => zoomMapOut()}>
        -
      </button>
    </div>
  );
};
